import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import { AppPenetrationAction, AppPenetrationPage } from '../../models';
import { buildShimUrl } from '../OpenAppBanner/constants';
import { trackAppPenetration } from './tracking';
import { useOpenAppDialogStyles } from './style';

/**
 * Presentational dialog pushing the native app. Visibility rules belong to
 * the callers (GlobalOpenAppDialog, SellingAreaOpenAppDialog).
 */
export default function OpenAppDialog({
	open,
	action,
	page,
	onClose,
}: {
	open: boolean;
	action: AppPenetrationAction;
	page: AppPenetrationPage;
	onClose: () => void;
}) {
	const classes = useOpenAppDialogStyles();

	useEffect(() => {
		if (open) {
			trackAppPenetration('View', action, page);
		}
	}, [open, action, page]);

	const close = () => {
		trackAppPenetration('Close', action, page);
		onClose();
	};

	return (
		<Dialog
			open={open}
			onClose={close}
			classes={{ paper: classes.paper }}
			aria-labelledby="open-app-dialog-title"
			aria-describedby="open-app-dialog-content"
		>
			<div className={classes.header}>
				{action.imageUrl
					? <img className={classes.image} src={action.imageUrl} alt="" />
					: <PhoneIphoneIcon className={classes.headerIcon} />}
				<IconButton className={classes.closeButton} aria-label="Chiudi" size="small" onClick={close}>
					<CloseIcon fontSize="small" />
				</IconButton>
			</div>
			<div className={classes.body}>
				<Typography id="open-app-dialog-title" variant="h5" component="h2" className={classes.title}>
					{action.title}
				</Typography>
				{action.content && (
					<Typography id="open-app-dialog-content" variant="body1" className={classes.content}>
						{action.content}
					</Typography>
				)}
			</div>
			<div className={classes.actions}>
				{/*
					A real anchor, not a JS navigation: iOS only treats a genuine anchor tap
					as a Universal Link. Never preventDefault here, or the app won't open.
				*/}
				<Button
					component="a"
					href={action.ctaLink || buildShimUrl()}
					target="_self"
					variant="contained"
					disableElevation
					fullWidth
					className={classes.cta}
					onClick={() => {
						trackAppPenetration('Click', action, page);
						onClose();
					}}
				>
					{action.ctaLabel}
				</Button>
				<Button fullWidth className={classes.dismiss} onClick={close}>
					{action.dismissLabel}
				</Button>
			</div>
		</Dialog>
	);
}
